var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-center justify-center"},[_c('span',[_vm._v(_vm._s(_vm.webNotes))]),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.startEditingDialog()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.webNotes ? 'mdi-pencil' : 'mdi-plus')+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }